import fetch from 'cross-fetch';
import { ApiPrefix, statusCheck, json, getCookie } from 'util/icwUtility';
import { actNotificationAdd } from './notificationActions';
import { actLoginTimedOut } from './loginStateActions';

export const TAGS_INIT = 'TAGS_INIT';
export function actTagsInit() {
  return { type: TAGS_INIT };
}

//
//  ******* Fetch Related *******
//
export const TAGS_FETCH_BEGIN = 'TAGS_FETCH_BEGIN';
function actTagsFetchBegin() {
  return { type: TAGS_FETCH_BEGIN };
}

export const TAGS_FETCH_SUCCESS = 'TAGS_FETCH_SUCCESS';
export function actTagsFetchSuccess(data) {
  return { type: TAGS_FETCH_SUCCESS, data };
}

export const TAGS_FETCH_FAIL = 'TAGS_FETCH_FAIL';
function actTagsFetchFail(error) {
  return { type: TAGS_FETCH_FAIL, error };
}

export function actTagsFetch() {
  return (dispatch) => {
    dispatch(actTagsFetchBegin());
    return fetch(`${ApiPrefix}/tags`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then(
        (data) => dispatch(actTagsFetchSuccess(data)),
        (err) => {
          if (err.status === 401) {
            dispatch(actLoginTimedOut());
          }

          dispatch(actTagsFetchFail(typeof err === 'object' ? err.message : err));
        }
      );
  };
}

//
//  ******* Create Related *******
//
export const TAG_CREATE_BEGIN = 'TAG_CREATE_BEGIN';
function actTagCreateBegin() {
  return { type: TAG_CREATE_BEGIN };
}

export const TAG_CREATE_SUCCESS = 'TAG_CREATE_SUCCESS';
export function actTagCreateSuccess(tag) {
  return { type: TAG_CREATE_SUCCESS, tag };
}

export const TAG_CREATE_FAIL = 'TAG_CREATE_FAIL';
function actTagCreateFail(error) {
  return { type: TAG_CREATE_FAIL, error };
}

export function actTagCreate(tag) {
  return (dispatch, getState) => {
    dispatch(actTagCreateBegin());
    return fetch(`${ApiPrefix}/tags/`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(tag),
    })
      .then(statusCheck)
      .then(json)
      .then(
        (data) => {
          if (getState().tags.data.findIndex(({ id }) => data.id === id) !== -1) {
            dispatch(
              actNotificationAdd({
                message: 'tagManagement.tagExisted',
                params: data.name,
              })
            );
          } else {
            dispatch(actTagCreateSuccess(data));
            dispatch(
              actNotificationAdd({
                variant: 'success',
                message: 'tagManagement.tagCreateSuccess',
              })
            );
          }
        },
        (err) => {
          if (err.status === 401) {
            dispatch(actLoginTimedOut());
          }

          dispatch(actTagCreateFail(typeof err === 'object' ? err.message : err));
        }
      );
  };
}

//
//  ******* Update Related *******
//
export const TAG_UPDATE_BEGIN = 'TAG_UPDATE_BEGIN';
function actTagUpdateBegin() {
  return { type: TAG_UPDATE_BEGIN };
}

export const TAG_UPDATE_SUCCESS = 'TAG_UPDATE_SUCCESS';
function actTagUpdateSuccess(newData, index) {
  return { type: TAG_UPDATE_SUCCESS, newData, index };
}

export const TAG_UPDATE_FAIL = 'TAG_UPDATE_FAIL';
function actTagUpdateFail(error) {
  return { type: TAG_UPDATE_FAIL, error };
}

export function actTagUpdate({ id: tagId, name }) {
  return (dispatch, getState) => {
    dispatch(actTagUpdateBegin());
    return fetch(`${ApiPrefix}/tags/${tagId}`, {
      method: 'PUT',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name }),
    })
      .then(statusCheck)
      .then(json)
      .then(
        (data) => {
          const tagList = getState().tags.data;
          const updateIdx = tagList.findIndex(({ id }) => id === tagId);
          dispatch(actTagUpdateSuccess(data, updateIdx));
          dispatch(
            actNotificationAdd({
              variant: 'success',
              message: 'tagManagement.tagUpdateSuccess',
              params: name,
            })
          );
        },
        (err) => {
          if (err.status === 401) {
            dispatch(actLoginTimedOut());
          }

          dispatch(actTagUpdateFail(typeof err === 'object' ? err.message : err));
        }
      );
  };
}

//
//  ******* Delete Related *******
//
export const TAG_DELETE_BEGIN = 'TAG_DELETE_BEGIN';
function actTagDeleteBegin() {
  return { type: TAG_DELETE_BEGIN };
}

export const TAG_DELETE_SUCCESS = 'TAG_DELETE_SUCCESS';
export function actTagDeleteSuccess(index) {
  return { type: TAG_DELETE_SUCCESS, index };
}

export const TAG_DELETE_FAIL = 'TAG_DELETE_FAIL';
function actTagDeleteFail(error) {
  return { type: TAG_DELETE_FAIL, error };
}

export function actTagDelete({ id: tagId }) {
  return (dispatch, getState) => {
    dispatch(actTagDeleteBegin());
    return (
      fetch(`${ApiPrefix}/tags/${tagId}`, {
        method: 'DELETE',
        headers: {
          Authorization: getCookie('token'),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then(statusCheck)
        // .then(json)
        .then(
          () => {
            const tagList = getState().tags.data;
            const deleteIdx = tagList.findIndex(({ id }) => id === tagId);
            dispatch(actTagDeleteSuccess(deleteIdx));
          },
          (err) => {
            if (err.status === 401) {
              dispatch(actLoginTimedOut());
            }

            dispatch(actTagDeleteFail(typeof err === 'object' ? err.message : err));
          }
        )
    );
  };
}

//
//  ******* Assign Supplier Related *******
//
export const TAG_SUPPLIER_ASSIGN_BEGIN = 'TAG_SUPPLIER_ASSIGN_BEGIN';
function actTagSuppliersAssignBegin() {
  return { type: TAG_SUPPLIER_ASSIGN_BEGIN };
}

export const TAG_SUPPLIER_ASSIGN_SUCCESS = 'TAG_SUPPLIER_ASSIGN_SUCCESS';
export function actTagSuppliersAssignSuccess() {
  return { type: TAG_SUPPLIER_ASSIGN_SUCCESS };
}

export const TAG_SUPPLIER_ASSIGN_FAIL = 'TAG_SUPPLIER_ASSIGN_FAIL';
function actTagSuppliersAssignFail(error) {
  return { type: TAG_SUPPLIER_ASSIGN_FAIL, error };
}

export function actTagSuppliersAssign(tag, selectedSuppliers, data = []) {
  return (dispatch) => {
    const suppliers = [
      ...new Set(selectedSuppliers.concat(data).map((supplier) => ({ id: supplier.id }))),
    ];
    dispatch(actTagSuppliersAssignBegin());
    return fetch(`${ApiPrefix}/tags/${tag.id}/suppliers`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(suppliers),
    })
      .then(statusCheck)
      .then(
        () => dispatch(actTagSuppliersAssignSuccess()),
        (err) => {
          if (err.status === 401) {
            dispatch(actLoginTimedOut());
          }

          dispatch(actTagSuppliersAssignFail(typeof err === 'object' ? err.message : err));
        }
      );
  };
}

//
//  ******* Fetch Tagged Suppliers Related *******
//
export const TAGGED_SUPPLIERS_FETCH_BEGIN = 'TAGGED_SUPPLIERS_FETCH_BEGIN';
function actTaggedSuppliersFetchBegin() {
  return { type: TAGGED_SUPPLIERS_FETCH_BEGIN };
}

export const TAGGED_SUPPLIERS_FETCH_SUCCESS = 'TAGGED_SUPPLIERS_FETCH_SUCCESS';
function actTaggedSuppliersFetchSuccess(tag, currentSuppliers) {
  return { type: TAGGED_SUPPLIERS_FETCH_SUCCESS, tag, currentSuppliers };
}

export const TAGGED_SUPPLIERS_FETCH_FAIL = 'TAGGED_SUPPLIERS_FETCH_FAIL';
function actTaggedSuppliersFetchFail(error) {
  return { type: TAGGED_SUPPLIERS_FETCH_FAIL, error };
}

export function actTaggedSuppliersFetch(tag) {
  return (dispatch) => {
    dispatch(actTaggedSuppliersFetchBegin());
    return fetch(`${ApiPrefix}/tags/${tag.id}/suppliers`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then(
        (suppliers) => dispatch(actTaggedSuppliersFetchSuccess(tag, suppliers)),
        (err) => {
          if (err.status === 401) {
            dispatch(actLoginTimedOut());
          }

          dispatch(actTaggedSuppliersFetchFail(typeof err === 'object' ? err.message : err));
        }
      );
  };
}

//
//  ******* Remove Supplier Tag Related *******
//
export const TAG_SUPPLIER_REMOVE_BEGIN = 'TAG_SUPPLIER_REMOVE_BEGIN';
function actTagSupplierRemoveBegin() {
  return { type: TAG_SUPPLIER_REMOVE_BEGIN };
}

export const TAG_SUPPLIER_REMOVE_SUCCESS = 'TAG_SUPPLIER_REMOVE_SUCCESS';
export function actTagSupplierRemoveSuccess(data) {
  return { type: TAG_SUPPLIER_REMOVE_SUCCESS, data };
}

export const TAG_SUPPLIER_REMOVE_FAIL = 'TAG_SUPPLIER_REMOVE_FAIL';
function actTagSupplierRemoveFail(error) {
  return { type: TAG_SUPPLIER_REMOVE_FAIL, error };
}

export function actTagSupplierRemove(tagId, selectedSuppliers) {
  return (dispatch) => {
    dispatch(actTagSupplierRemoveBegin());
    return fetch(`${ApiPrefix}/tags/${tagId}/suppliers`, {
      method: 'DELETE',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(selectedSuppliers),
    })
      .then(statusCheck)
      .then(
        () => dispatch(actTagSupplierRemoveSuccess()),
        (err) => {
          if (err.status === 401) {
            dispatch(actLoginTimedOut());
          }

          dispatch(actTagSupplierRemoveFail(typeof err === 'object' ? err.message : err));
        }
      );
  };
}

export const TAGS_RESET = 'TAGS_RESET';
export function actTagsReset() {
  return { type: TAGS_RESET };
}
